import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import PublicOrganizationBookingForm from '@bookings/components/public-organization-booking-form/public-organization-booking-form.vue';

@Component({
  name: 'bpc-profile-new-organization-booking',
  components: {
    'bpc-public-organization-booking-form': PublicOrganizationBookingForm,
  },
})
export default class ProfileNewOrganizationBooking extends Vue {
  /* Lifecycle hooks */
  // created () { }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
